import type React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { CircularProgress, Grid } from '@mui/material';
import { useTranslation } from 'common';
import { useMobileDeviceNavbarStyles } from '../../MobileDeviceNavbar.styles';
import { useZeventTileStyles } from './ZeventTile.styles';
import { ReactComponent as ArrowIcon } from '../../../../../images/Pil.svg';
import { fetchRequest } from '../../../../../api/fetch';

const useIsMobile = (breakpoint = 768): boolean => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};

const ZeventTile: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navbarClasses = useMobileDeviceNavbarStyles();
  const tileClasses = useZeventTileStyles();
  const { translateString } = useTranslation();
  const isMobile = useIsMobile();

  const handleClick = useCallback(async () => {
    if (loading) return; // Prevent multiple clicks

    setLoading(true);

    try {
      const response = await fetchRequest('/members/me/zarrangement/remote-login-url');

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const url = await response.text();

      if (isMobile) {
        window.location.href = url;
      } else {
        window.open(url, '_blank');
      }
    } catch (error) {
      console.error('Failed to fetch URL', error);
    } finally {
      setLoading(false);
    }
  }, [loading, isMobile]);

  return (
    <button type="button" className={`${navbarClasses.tile} ${tileClasses.root} ${tileClasses.event}`} onClick={handleClick}>
      <Grid container spacing={1} className={navbarClasses.tilePadding}>
        <Grid item sm={12}>
          <div className={`${navbarClasses.tileText} ${tileClasses.eventHeading}`}>
            {translateString('Events')} {loading && <CircularProgress color="inherit" size={20} />}
          </div>
        </Grid>
        <div className={navbarClasses.playIcon} style={{ position: 'absolute', right: 10, bottom: -10 }}>
          <ArrowIcon />
        </div>
      </Grid>
    </button>
  );
};

export default ZeventTile;
